/* global System */
import withLazyUnveil from 'scripts/higher-order-components/withLazyUnveil'
// register component(s) with react habitat

export default {
  CountUp: withLazyUnveil({
    loadComponent: () =>
      System.import(
        /* webpackChunkName: "CountUp" */
        './index'
      ),
    height: 118,
    mobileHeight: 118,
    extraPlaceholderProps: {
      // https://github.com/aFarkas/lazysizes#data-expand-attribute
      'data-expand': -10,
    },
  }),
}
